<a routerLink="/">Home</a> / <a routerLink="/accounts">Market Profiles</a> / Details
<br/><br/>
<div class="row page-header">
  <div class="col button-back" role="button">
    <a routerLink="/market-profiles"><mat-icon>arrow_back</mat-icon></a>
  </div>
  <div class="col title">
    <h1>Market Profile Details</h1>
  </div>
</div>
<div class="row">
  <div class="col">
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate" class=""></mat-progress-bar>
    <mat-card>
      <div *ngIf="brochureData | async; let data">
        <mat-card-header>
          <mat-icon mat-card-avatar>assignment</mat-icon>
          <mat-card-title>{{ data.name }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="row">
            <div class="col-md-6 form-label">Name</div>
            <div class="col-md-6 form-text">{{ data.name }}</div>
          </div>
          <div class="row">
            <div class="col-md-6 form-label">Created</div>
            <div class="col-md-6 form-text">{{ data.createdAt | date : "dd MMM yyyy hh:mm" }}</div>
          </div>
          <div class="row">
            <div class="col-md-6 form-label">Available for guest</div>
            <div class="col-md-6 form-text">{{ data.isAvailableForGuest ? 'Yes': 'No'}}</div>
          </div>
          <div class="row">
            <div class="col-md-6 form-label">Available for retail</div>
            <div class="col-md-6 form-text">{{ data.isAvailableForRetail ? 'Yes': 'No'}}</div>
          </div>
          <div class="row">
            <div class="col-md-6 form-label">Number of products</div>
            <div class="col-md-6 form-text">{{ data.productCodes?.length || 0 }}</div>
          </div>
          <br/>
        </mat-card-content>
        <mat-divider></mat-divider>
        <mat-card-actions>
          <button
            mat-flat-button color="primary"
            routerLink="/market-profiles/{{brochureId}}/edit"
          >
            Edit
          </button>
        </mat-card-actions>
      </div>
    </mat-card>
  </div>
</div>
